<div>
    @if (!isLoading) {
        <form-linkable
            displayValueProp="name"
            [linkedModule]="linkedModule"
            [linked]="linked"
            [unlinked]="unlinked"
            [disabled]="disabled"
            [hideActions]="true"
            (linkedChange)="linkedItemsChanged($event)"
        ></form-linkable>
    }
</div>
